import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.scss'],
})
export class AuthCallbackComponent implements OnInit {
  returnUrl: string;
  isLoading = true;

  constructor(private authService: AuthService, private route: ActivatedRoute) {
    this.returnUrl = '';
  }

  ngOnInit(): void {
    if (this.route.snapshot.queryParams) {
      this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
    }
    this.authService.completeAuthentication();
  }
}
